// src/components/LoginLayout.js
import React, { useEffect, useState } from 'react';
import '../styles/LoginSignup.css';

// Mensagens que refletem o valor do seu app
const messages = [
  "Gestão de talentos é o que impulsiona grandes resultados.",
  "A força da sua empresa começa pelas pessoas que a constroem.",
  "Engajar e desenvolver pessoas: o caminho para o sucesso sustentável.",
  "A liderança começa com empatia: entender pessoas é o primeiro passo para guiá-las ao sucesso."
];

const LoginLayout = ({ children }) => {
  const [displayText, setDisplayText] = useState('');
  
  useEffect(() => {
    let currentMessageIndex = 0;
    let charIndex = 0;
    let isDeleting = false;
    let timeoutId;

    const typeWriter = () => {
      const currentMessage = messages[currentMessageIndex];
      // Velocidade padrão da digitação e exclusão
      let delay = 100;

      if (isDeleting) {
        // Apagando o texto
        setDisplayText(currentMessage.substring(0, charIndex - 1));
        charIndex--;
        delay = 50; // Deixa a exclusão mais rápida
      } else {
        // Escrevendo o texto
        setDisplayText(currentMessage.substring(0, charIndex + 1));
        charIndex++;
      }

      // Lógica para transição de estados
      if (!isDeleting && charIndex === currentMessage.length) {
        // Se terminou de escrever, pausa por 2s e começa a apagar
        delay = 2000;
        isDeleting = true;
      } else if (isDeleting && charIndex === 0) {
        // Se terminou de apagar, vai para a próxima mensagem
        isDeleting = false;
        currentMessageIndex = (currentMessageIndex + 1) % messages.length;
        delay = 500; // Pausa antes de começar a nova mensagem
      }

      timeoutId = setTimeout(typeWriter, delay);
    };

    // Inicia a animação
    timeoutId = setTimeout(typeWriter, 100);

    // Função de limpeza para interromper a animação quando o componente for desmontado
    return () => clearTimeout(timeoutId);
    
  }, []); // O array vazio [] garante que o efeito rode apenas uma vez

  return (
    <div className="app-container">
      {/* Coluna da Esquerda (agora com o Formulário) */}
      <div className="right-container">
        {children}
      </div>

      {/* Coluna da Direita (agora com o Branding/Marketing) */}
      <div className="left-container">
        <div className="slogan-container">
          <h1 className="slogan-title">Transforme sua Gestão de Pessoas</h1>
          <p className="slogan">
            {displayText}
            <span className="cursor"></span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginLayout;